import { userConstants } from './../constants/user.constants';

const initialState = {};

export function createInst(state = initialState, action) {
  switch (action.type) {
    case userConstants.CREATEINST_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CREATEINST_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CREATEINST_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}